import { Badge } from '@/components/ui/badge';
import { confidenceTone, formatConfidence } from '@/lib/utils';

export function ConfidenceBadge({
  value,
  lowVariant = 'destructive',
}: {
  value: number | null;
  lowVariant?: 'destructive' | 'warning';
}): JSX.Element {
  if (value === null) {
    return <Badge variant="outline">-</Badge>;
  }
  const tone = confidenceTone(value);
  const variant = tone === 'high' ? 'success' : tone === 'medium' ? 'warning' : lowVariant;
  return <Badge variant={variant}>{formatConfidence(value)}</Badge>;
}
